import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import './index.scss';
import DeepSavedPrompts from './DeepSavedPrompts';
import { updateQuickPrompts } from '../../store/aiearth/action';
import { SidebarProps } from '../../types/deep-research';

import { LibraryBooks as LibraryBooksIcon, }  from '@material-ui/icons';

const Sidebar: React.FC<SidebarProps> = ({
  isHovered,
  setIsHovered,
  setSearchText,
  savedDeepChats,
  activeSavedChatId,
  onSelectSavedChat,
  onNewChat,
}) => {

  const [showSavePrompt, setShowSavePrompt] = useState(false);

  const dispatch = useDispatch();

  const onCopyTextHandler = (title: string) => {
    setSearchText(title);
  };

  const promptChangesHandler = (promptsData: any) => {
    // Flatten the nested arrays using flat()
    const promptsList = promptsData.flatMap((items: any) => items.payload.promptData).flat(2);
    dispatch(updateQuickPrompts(promptsList));
  };

  const handleMenuClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.dispatchEvent(new Event('ceres-open-main-sidebar'));
  };

  return (
    <>
      { showSavePrompt &&
        <DeepSavedPrompts closeSavedPrompt={() => setShowSavePrompt(false)} onCopyText={(title: string) => onCopyTextHandler(title)} onPromptsChange={promptChangesHandler} />}
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`sidebar ${isHovered ? 'expanded' : 'collapsed'}`}
      >
        {/* Top Section */}
        <div>
          <Nav className={`nav-top ${!isHovered ? 'centered' : ''}`}>
            <Nav.Link
              as="button"
              type="button"
              className="nav-link"
              onClick={handleMenuClick}
            >
              <i className="bi bi-list"></i>
              {isHovered && <span className="label">Menu</span>}
            </Nav.Link>

            <Nav.Link
              as="button"
              type="button"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                onNewChat();
              }}
            >
              <i className="bi bi-pencil-square"></i>
              {isHovered && <span className="label">New chat</span>}
            </Nav.Link>


            <Nav.Link className="nav-link" onClick={() => setShowSavePrompt(true)}>
              <LibraryBooksIcon /> {isHovered && <span className="label">Saved Prompts</span>}
            </Nav.Link>

          </Nav>

          {isHovered && (
            <>
              <div className="section-heading">
                Chats
              </div>
              <div className="recent-list">
                {savedDeepChats.length === 0 ? (
                  <p className="recent-empty">Your research threads appear here. Start a search to create one.</p>
                ) : (
                  savedDeepChats.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      className={`recent-list-item${activeSavedChatId === item.id ? ' is-active' : ''}`}
                      title={item.mainTitle}
                      onClick={() => onSelectSavedChat(item.id)}
                    >
                      {item.mainTitle}
                    </button>
                  ))
                )}
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <Nav className={`nav-footer ${!isHovered ? 'centered' : ''}`}>
          <Nav.Link className="nav-link">
            <i className="bi bi-gear"></i>
            {isHovered && <span className="label">Settings & help</span>}
          </Nav.Link>
        </Nav>
      </div>
    </>
  );
};

export default Sidebar;
